export const initialValues = {
  businessDomain: '',
  overview: '',
  platforms: '',
  name: '',
  email: '',
}
